import type { ReactNode } from "react";

import { Tabs } from "@omnabase/ui";
import { useNav, useWs, useNavigate } from "../../lib/nav";
import { useSession } from "../../shell/store";
import { useCan } from "../../lib/access";

/** The Team page's head, shared by its three tabs: people, the roles they hold (ported) and, since the working hours round (2026-11-01),
 *  everyone's working hours. Every member opens it; the actions (Invite, New role) are the team right's, the screens pass none to others. */
export type TeamTab = "members" | "roles" | "hours";
const TAB_PATHS: Record<TeamTab, string> = { members: "/settings/team", roles: "/settings/team/roles", hours: "/settings/team/hours" };
export function TeamHead({ active, actions }: { active: TeamTab; actions?: ReactNode }) {
  const nav = useNav();
  const navigate = useNavigate();
  const { ws } = useWs();
  const { workspace } = useSession();
  const canBill = useCan()("billing"); // Billing is in the column of those who may buy only (2026-10-05)
  const seats = workspace.seats.included === null ? `${workspace.seats.used} ${workspace.seats.used === 1 ? "seat" : "seats"} used` : `${workspace.seats.used} of ${workspace.seats.included} seats used`;
  return (
    <header className="ob-profile__head">
      <div className="ob-settings__head">
        <div><h1 className="ob-page__title">Team</h1><p className="ob-page__subtitle ob-settings__seats">{seats}{canBill && <> · <a className="ob-link" href={ws("/settings/billing")} onClick={(e) => nav(ws("/settings/billing"), e)}>Billing</a></>}</p></div>
        {actions && <div className="ob-settings__head-actions">{actions}</div>}
      </div>
      <Tabs variant="line" items={[{ id: "members", label: "Members", count: workspace.members.length + workspace.invitations.length }, { id: "roles", label: "Roles", count: workspace.roles.length }, { id: "hours", label: "Working hours" }]} active={active} onChange={(id) => navigate(ws(TAB_PATHS[id as TeamTab] ?? TAB_PATHS.members))} />
    </header>
  );
}
